import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const DEFAULTS = {
  brand_name: "REFLLEXIVE",
  tagline: "REFLEXÃO | MENTALIDADE | EVOLUÇÃO",
  hero_line_1: "SAIA DO",
  hero_line_2: "AUTOMÁTICO.",
  hero_subtitle: "Para quem quer sair do automático.",
  marquee_text: "REFLEXÃO ✦ MENTALIDADE ✦ EVOLUÇÃO ✦ DISCIPLINA ✦",
  about_title: "O despertar começa com uma pergunta.",
  about_text: "",
  manifesto: [
    { title: "REFLEXÃO", text: "" },
    { title: "MENTALIDADE", text: "" },
    { title: "EVOLUÇÃO", text: "" },
  ],
  instagram_url: "https://instagram.com/refllexive",
  whatsapp: "5500000000000",
  newsletter_title: "Receba a reflexão da semana.",
  newsletter_text: "",
  community_title: "A Comunidade REFLLEXIVE",
  community_text: "",
};

const SiteContext = createContext({ site: DEFAULTS, setSite: () => {} });

export function SiteProvider({ children }) {
  const [site, setSite] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setSite({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);

  return (
    <SiteContext.Provider value={{ site, setSite }}>{children}</SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
